import { lazy, Suspense, useEffect } from 'react';
import { Drawer } from 'antd';
import styled from 'styled-components';
import CloseAlerts from 'Components/alerts/assets/svg/CloseAlerts';
import { maxMobile, scrollbar } from 'Utils/utilsStyle';
import { Alert } from 'Types/ArticleTypes';

const ArticleInfo = lazy(() => import('./ArticleInfo'));

const Wrapper = styled.div`
  position: relative;
  padding: 0px;
`;

const ScrollWrapper = styled.div`
  margin: 0px 10px 0 20px;
  padding: 10px 8px 10px 10px;
  height: calc(100vh - 57px);
  ${scrollbar};
  @media all and (max-width: ${maxMobile}) {
    height: calc(100vh - 90px);
  }
`;

type Props = {
  visible?: boolean;
  articleId: number;
  toggleVisible: () => void;
  title?: string,
  domain?: string,
  dateTimeStamp?: string,
  summary?: string,
  image?: string,
  url?: string,
  alertId?: number
  companyId?: number
  companyName?: string
  spotlight?: boolean
  articleAlert?: Alert[]
};
const defaultProps = {
  visible: false,
  title: '',
  domain: '',
  dateTimeStamp: '',
  summary: '',
  image: '',
  url: '',
  alertId: 0,
  companyId: 0,
  companyName: '',
  spotlight: false,
  articleAlert: [],
};
const ArticleDrawer = function ArticleDrawer(props: Props) {
  const {
    visible,
    toggleVisible,
    articleId,
    title,
    domain,
    dateTimeStamp,
    summary,
    image,
    url,
    alertId,
    companyId,
    companyName,
    spotlight,
    articleAlert,
  } = props;

  useEffect(() => {
    const node = document.querySelector('body');
    return visible ? node?.classList.add('body-drawer-toggle') : node?.classList.remove('body-drawer-toggle');
  }, [visible]);

  return (
    <Wrapper>
      <Drawer
        className="drawer-alerts people-group-drawer article-preview"
        placement="right"
        visible={visible}
        onClose={toggleVisible}
        width={609}
        extra={(
          <span onClick={toggleVisible} onKeyPress={toggleVisible} tabIndex={0} role="button" aria-label="close" className="close-alerts"><CloseAlerts /></span>
        )}
      >
        <ScrollWrapper className="detail-drawer-scroll">
          <Suspense
            fallback={
              <div />
            }
          >
            <ArticleInfo
              articleId={articleId}
              visible={visible}
              title={title}
              domain={domain}
              dateTimeStamp={dateTimeStamp}
              summary={summary}
              image={image}
              url={url}
              alertId={alertId}
              companyId={companyId}
              companyName={companyName}
              spotlight={spotlight}
              articleAlert={articleAlert}
            />
          </Suspense>
        </ScrollWrapper>
      </Drawer>
    </Wrapper>
  );
};

ArticleDrawer.defaultProps = defaultProps;
export default ArticleDrawer;
